import { render, staticRenderFns } from "./SecurityTabs.vue?vue&type=template&id=2f7ab45e&"
import script from "./SecurityTabs.vue?vue&type=script&lang=js&"
export * from "./SecurityTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports